import * as React from 'react';
import {Shop} from 'interfaces';
import {autobind} from '@shopify/javascript-utilities/decorators';

export interface Props {
  shop: Shop;
  showOnlyIndustry?: boolean;
}

export interface State {
  deltaX: number;
}

export class Categories extends React.PureComponent<Props, State> {
  startX: number = 0;
  throttleDrag: number = 0;
  categoriesHolder: any;
  categoriesHolderParent: any;
  setCategoriesHolderRef: any = {};
  setCategoriesHolderParentRef: any = {};

  constructor(props) {
    super(props);

    this.state = {
      deltaX: 0,
    };

    this.setCategoriesHolderRef = (element) => {
      this.categoriesHolder = element;
    };

    this.setCategoriesHolderParentRef = (element) => {
      this.categoriesHolderParent = element;
    };
  }

  componentWillUnmount() {
    if (this.throttleDrag > 0) {
      window.cancelAnimationFrame(this.throttleDrag);
    }
  }

  @autobind
  handleStart(event) {
    this.handleNoop(event);
    window.addEventListener('mousemove', this.handleDrag);
    window.addEventListener('mouseup', this.handleEnd);
    window.addEventListener('touchmove', this.handleDrag);
    window.addEventListener('touchend', this.handleEnd);

    const clientCoordinateStyle = 'clientX';
    const clientX = event.touches
      ? event.touches[0][clientCoordinateStyle]
      : event[clientCoordinateStyle];
    this.startX = clientX + this.state.deltaX;
  }

  @autobind
  handleDrag(event) {
    if (!this.categoriesHolder || !this.categoriesHolderParent) {
      return;
    }

    if (this.throttleDrag > 0) {
      this.throttleDrag = 0;
      return;
    }

    this.categoriesHolder.className = 'shop-tile__categories-handle dragging';
    this.handleNoop(event);
    const clientCoordinateStyle = 'clientX';
    const clientX = event.touches
      ? event.touches[0][clientCoordinateStyle]
      : event[clientCoordinateStyle];
    const maxWidth = this.categoriesHolder.clientWidth - this.categoriesHolderParent.clientWidth;
    const deltaX = Math.min(Math.max((this.startX - clientX), 0), maxWidth);
    this.setState({deltaX});

    window.requestAnimationFrame((id) => {
      this.throttleDrag = id;
    });
  }

  @autobind
  handleEnd(event) {
    this.handleNoop(event);
    window.removeEventListener('mousemove', this.handleDrag);
    window.removeEventListener('mouseup', this.handleEnd);
    window.removeEventListener('touchmove', this.handleDrag);
    window.removeEventListener('touchend', this.handleEnd);

    if (this.categoriesHolder) {
      this.categoriesHolder.className = 'shop-tile__categories-handle';
    }
  }

  @autobind
  handleNoop(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  renderCategories() {
    const {
      shop,
      showOnlyIndustry,
    } = this.props;
    const {
      categories,
      industry,
    } = shop;

    const items = showOnlyIndustry ? [industry] : [...categories.slice(0, 3)];
    const listItems = items.map((category) => {
      return category ? <li key={category.handle}><a className="shop-tile__category heading--truncated" href={`${category.url}`}>{category.title}</a></li> : null;
    });

    const styles = {
      transform: `translateX(-${this.state.deltaX}px)`,
    };

    return (
      <div
        className="shop-tile__categories-handle"
        onMouseDown={this.handleStart}
        onTouchStart={this.handleStart}
        ref={this.setCategoriesHolderRef}
        style={styles}
      >
        <ul>
          {listItems}
        </ul>
      </div>
    );
  }

  render() {
    const renderCategories = this.renderCategories();
    return (
      <div className="shop-tile__categories" ref={this.setCategoriesHolderParentRef}>
        {renderCategories}
      </div>
    );
  }
}

export default Categories;
